import { useQuery } from '@tanstack/react-query';
import { getPaymentAggregators } from './endpoints';
import { useMsId } from '../../../store/appStore';
import { storeNameKeys } from './keys';
import { isWixPaymentProviderSupported } from '../utils';

export function usePaymentProviders() {
  const metaSiteId = useMsId();

  return useQuery({
    queryKey: storeNameKeys.mutations.getPaymentAggregators(),
    queryFn: () => getPaymentAggregators(metaSiteId),
    enabled: !!metaSiteId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    select: (data) => ({
      providers: data,
      isAvailable: isWixPaymentProviderSupported(data),
    }),
  });
}




